import { render } from "./videoLearning.vue?vue&type=template&id=5487a39e&scoped=true"
import script from "./videoLearning.vue?vue&type=script&lang=js"
export * from "./videoLearning.vue?vue&type=script&lang=js"

import "./videoLearning.vue?vue&type=style&index=0&id=5487a39e&scoped=true&lang=css"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5487a39e"]])

export default __exports__